export interface IEntityDto { 
  id?: number;
  version?: number;
  isDeactivated?: boolean;
  fiscalSetupId?: number;
  createdAt?: Date;
}
